import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('facility.slug'),
	fieldsMap.get('facility.title'),
	fieldsMap.get('facility.description')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
